import type { Theme } from '@aws-amplify/ui-react';

// Custom theme for Amplify to match Traton theme
export const amplifyTheme: Theme = {
    name: 'custom-theme',
    tokens: {
        fonts: {
            default: {
                variable: { value: 'TRATON Type Text, "serif"' },
                static: { value: 'TRATON Type Text, "serif"' },
            },
        },
        components: {
            button: {
                primary: {
                    backgroundColor: {
                        value: '#328092', // primary color
                    },
                    _hover: {
                        backgroundColor: {
                            value: '#255F6C', // highlight.dark color
                        },
                    },
                },
                fontWeight: {
                    value: 400,
                },
            },
        },
    },
};
